import {
    TableInformationRendererProps,
    WidthAndHeightBlock,
} from "@inode/multi-table-explorer";
import { ITableResultMeta } from "@inode/types2";
import { Grid } from "@mui/material";
import { SqlHighlighter } from "#common/SqlHighlighter";
import React from "react";
import { P } from "#common/headings";
import { Link } from "#common/Link";
import { generatePath } from "react-router";
import { Routes } from "#/config/Routes";
import { useAppDispatch, useAppSelector } from "#store";
import { Interpretation } from "#services/pilotService/types";
import {
    selectInterpretationById,
    selectUiHistoryLatestInterpretationsByDate,
} from "#selectors";
import { addHistory, InteractionType } from "#store/ui";

export type InodeTableInformationProps = TableInformationRendererProps & {
    meta?: ITableResultMeta &
        Partial<{
            name: string;
            explanation: string;
            sql: string;
            caption: string;
            interpretationId?: number;
        }>;
};

export const InodeTableInformation = (props: InodeTableInformationProps) => {
    const { meta = {}, data = [], ordering } = props;

    const dispatch = useAppDispatch();

    const interpretation = useAppSelector(state =>
        selectInterpretationById(state, meta.interpretationId)
    );
    const userHighlight: Interpretation[] = useAppSelector(
        selectUiHistoryLatestInterpretationsByDate
    );
    const isHighlight = !!userHighlight.find(
        i => i.id === meta.interpretationId
    );

    const pieces = [];
    pieces.push(
        <Grid item key={"dimensions"} xs={2}>
            <WidthAndHeightBlock data={data} meta={meta} ordering={ordering} />
        </Grid>
    );
    pieces.push(
        <Grid item key={"cap"} xs={10}>
            {!meta.caption ? null : !meta.interpretationId ? (
                <P>{meta.caption}</P>
            ) : (
                <Link
                    to={generatePath(Routes.interpretation.path, {
                        id: String(meta.interpretationId),
                    })}
                >
                    {meta.caption}
                </Link>
            )}
            {meta.name ? <SqlHighlighter code={meta.name} /> : null}
        </Grid>
    );

    return (
        <Grid
            container
            maxWidth="xl"
            onMouseOver={() => {
                if (!isHighlight && interpretation) {
                    dispatch(
                        addHistory(interpretation, InteractionType.HIGHLIGHT)
                    );
                }
            }}
            sx={{
                borderLeftWidth: theme =>
                    isHighlight ? theme.spacing(2) : "0",
                borderLeftColor: theme =>
                    isHighlight ? theme.palette.primary.main : "",
                paddingLeft: theme => (isHighlight ? "0" : theme.spacing(2)),
                borderLeftStyle: "solid",
            }}
        >
            {pieces}
        </Grid>
    );
};
